import { memo } from "react";
import Button from "../button/Button";
import type { IconName } from "@/components/icons/icons";

export interface PrimaryButtonProps {
  label: string;
  colour: "black" | "red" | "white";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  onClick?: (() => void) | ((data: any) => void);
  icon?: IconName;
  iconPosition?: "left" | "right";
  width?: string;
  type?: "button" | "submit" | "reset";
}

const PrimaryButton = ({
  label,
  colour = "red",
  size,
  disabled = false,
  onClick = () => {},
  icon,
  iconPosition,
  width,
  type,
}: PrimaryButtonProps) => {
  return (
    <Button
      label={label}
      size={size}
      type={`primary-${colour}`}
      width={width}
      icon={icon}
      iconPosition={iconPosition}
      disabled={disabled}
      onClick={onClick}
      buttonType={type}
    />
  );
};

export default memo(PrimaryButton);
